import * as React from "react";
import { TooltipApi } from "sb-resp-ui";

export type ToggleOddsBtnType = {
    shouldShow: boolean
    toggled: boolean
    tooltipMessage: string
    onClick: Function
}

export class ToggleOddsBtn extends React.PureComponent<ToggleOddsBtnType> {

    btnRef: React.RefObject<HTMLDivElement>;

    setTooltipMsg: (message?: string) => { "data-tooltip-message": string; };

    onClickHandler = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        this.props.onClick();
    }

    constructor(props) {
        super(props);
        this.setTooltipMsg = TooltipApi.getInstance().setMessage.bind(this);
        this.btnRef = React.createRef();
    }

    componentDidUpdate() {
        if (this.btnRef.current) {
            TooltipApi.getInstance().refresh(this.btnRef.current)
        }
    }

    render() {
        let tooltip = this.setTooltipMsg(this.props.tooltipMessage);

        return (
            <div ref={this.btnRef} className={`rj-ev-list__toggle-odds-btn rj-ev-list__toggle-odds-btn--${this.props.toggled}`} onClick={this.onClickHandler} {...tooltip} data-uat="div-ev-list-toggle-odds-btn">
                <span className="icon i-14 i-o-ev-up-down"></span>
            </div>
        )
    }
}